import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../environment/environment';

@Component({
  selector: 'dbx-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly translateService = inject(TranslateService);
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    this.translateService.setDefaultLang('en');
    this.addSvgIcons();
    this.setPageTitle();
  }

  private addSvgIcons() {
    this.addSvgIcon('horizon');
    this.addSvgIcon('nessus');
  }

  private addSvgIcon(icon: string) {
    this.iconRegistry.addSvgIcon(icon, this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`));
  }

  private setPageTitle() {
    document.title = environment.branding.productName;
  }
}
